@if (!!value || showFieldAsEdit) {
  <div
    class="field"
    >
    <label class="upper">{{ displayName }} ({{ unitAbbrv }})</label>
    @if (showFieldAsEdit) {
      <div>
        <input
          [(ngModel)]="displayValue"
          (ngModelChange)="onValueChanged()"
          class="input is-small"
          type="text"
          [placeholder]="displayName" />
      </div>
    } @else {
      <div class="is-readonly">
        @if (displayFormat !== '') {
          <span>
            {{ displayValue | formatNumber : displayFormat }}
            @if (displayValue) {
              <span>{{ unitAbbrv }}</span>
            }
          </span>
        }
        @if (displayFormat === '') {
          <span>
            {{ displayValue }}
          </span>
        }
      </div>
    }
  </div>
}
